import type { Theme } from "@repo/tokens";

export function getNumericQuestionStyles(theme: Theme) {
  return {
    neutral: {
      borderColor: theme.colors.neutral[80],
      backgroundColor: theme.colors.neutral[100],
      textColor: theme.colors.neutral[20],
    },
    correct: {
      borderColor: theme.colors.success[60],
      backgroundColor: theme.colors.success[95],
      textColor: theme.colors.success[30],
    },
    wrong: {
      borderColor: theme.colors.error[60],
      backgroundColor: theme.colors.error[95],
      textColor: theme.colors.error[30],
    },
    keyNeutral: {
      backgroundColor: theme.colors.neutral[100],
      borderWidth: 1.5 as const,
      borderColor: theme.colors.neutral[80],
      borderRadius: 12,
      textColor: theme.colors.neutral[20],
    },
    keySelected: {
      backgroundColor: theme.colors.primary[30],
      borderWidth: 1.5 as const,
      borderColor: "transparent",
      borderRadius: 12,
      textColor: theme.colors.neutral[100],
    },
    keyPressed: {
      backgroundColor: theme.colors.primary[40],
      borderWidth: 1.5 as const,
      borderColor: "transparent",
      borderRadius: 12,
      textColor: theme.colors.neutral[100],
    },
  };
}
